import { createFileRoute, Outlet } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section } from '@/features/app-shell/section'

import { ErrorBoundary } from '@/components/common/error-boundary'

export const Route = createFileRoute('/_dashboard/integrations')({
	head: () => ({
		meta: [
			{
				title: 'Integrations | BitLyft AIR®',
			},
		],
	}),

	component: IntegrationsRoute,
	pendingComponent: IntegrationsSkeleton,
	errorComponent: RouteErrorComponent,
})

function IntegrationsRoute() {
	return (
		<ErrorBoundary feature="integrations">
			<Section>
				<Outlet />
			</Section>
		</ErrorBoundary>
	)
}

function IntegrationsSkeleton() {
	return (
		<Section>
			<Outlet />
		</Section>
	)
}
